export declare namespace ControlObjectSummaryCardTokenSections {
	interface Representative {
		borderColor: string;
	}
}

export type ControlObjectSummaryCardTokens = {
	representative: ControlObjectSummaryCardTokenSections.Representative;
};

export const representative: ControlObjectSummaryCardTokenSections.Representative = {
	borderColor: '{surface.100}',
};

export default {
	representative,
} satisfies ControlObjectSummaryCardTokens;
